import { useParams } from "react-router-dom";

export const useId = () => {
  const params = useParams<{ id: string }>();

  return params.id;
};
